import { useQuery } from "@tanstack/react-query";
import { api, UnauthorizedError } from "@/api/client";

export function useAuth() {
  const q = useQuery({
    queryKey: ["me"],
    queryFn: api.me,
    retry: (count, err) => !(err instanceof UnauthorizedError) && count < 1,
  });
  return {
    user: q.data ?? null,
    loading: q.isLoading,
    authenticated: !!q.data,
    unauthorized: q.error instanceof UnauthorizedError,
    error: q.error && !(q.error instanceof UnauthorizedError) ? q.error : null,
  };
}
